module.exports = __webpack_public_path__ + "static/media/comment.37292df2.svg";